import { LineByLineIcon } from '@sparemin/blockhead';
import React from 'react';

import { hexToRgba } from 'utils/color';
import { AnimationModule } from '../../types';
import useTextOverlayAdvancedAnimation from '../../useTextOverlayAdvancedAnimation';
import AnimationModuleButton from '../AnimationModuleButton';
import ActiveLineScrollAnimationControls from './ActiveLineScrollAnimationControls';

export interface ActiveLineScrollAnimationModuleProps {}

const DEFAULT_LINE_FUTURE_COLOR = hexToRgba('#FFFFFF', 0.5);
const DEFAULT_LINE_BACKGROUND_COLOR = 'rgba(0, 0, 0, 1)';
const DEFAULT_LINE_BACKGROUND_RADIUS = '0vw';

const ActiveLineScrollAnimation: React.FC<ActiveLineScrollAnimationModuleProps> = () => {
  const {
    selectedAdvancedAnimation,
    onTurnOnAdvancedAnimation,
  } = useTextOverlayAdvancedAnimation();

  return (
    <AnimationModuleButton
      label="Line By Line"
      icon={<LineByLineIcon width={50} height={50} />}
      isSelected={
        selectedAdvancedAnimation?.enabled &&
        selectedAdvancedAnimation?.animationName === 'activeLineScroll'
      }
      onPress={() => {
        onTurnOnAdvancedAnimation(
          'activeLineScroll',
          {
            lineFutureColor: DEFAULT_LINE_FUTURE_COLOR,
            lineBackgroundColor: DEFAULT_LINE_BACKGROUND_COLOR,
            lineBackgroundRadius: DEFAULT_LINE_BACKGROUND_RADIUS,
          },
          { defaultVisibleLines: 2 },
        );
      }}
    />
  );
};

const activeLineScrollAnimationModule: AnimationModule = {
  key: 'activeLineScroll',
  name: 'Line By Line',
  control: ActiveLineScrollAnimation,
  contents: <ActiveLineScrollAnimationControls />,
};

export default activeLineScrollAnimationModule;
